import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { Subscription, timer } from 'rxjs';
import * as environmentUrl from 'src/environments/environment';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-information',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  ptsUrl = environmentUrl.environment.ptsUrl;
  candidateArray: any = [];
  public showManual = false;
  public changeSymptoms = false;
  showNoCandidate = false;
  clickShowNoconnection = false;
  public vinNumber = '';
  public tokenObj: any;
  public userId: any;
  public sessionId: any;
  flag = false;
  public isShowCandidateWhenNull = false;
  public isFDRSConnected = false;
  public isDiagnosticViewFaultFound: boolean = false;
  public diagnosticViewStatusObj: any;
  public faultString: string = '';
  public repairStatus: string = '';
  public selectedFaultObj: Object = {};
  resume = false;
  isshowLoader = true;
  arrayData: any;
  change: Object = {};
  timer: any;
  subscription: Subscription = new Subscription;
  res: any;
  country: any;
  language: any;
  market: any;
  username: any;
  userType: any;
  invinnumber: any;
  candidateFailed: boolean = false;
  isNWTestCompletedOrOverridedFromResume: boolean = false;
  pageDataSubscription: Subscription = new Subscription;
  otxDataSubscription: Subscription = new Subscription;
  resumeSubscription: Subscription = new Subscription;
  skipDiagnosticProcedureArray: any = [{}];
  isShowSkipCheckbox: boolean = false;
  userTypeId: any;
  isDisableSelectAllCheckbox: boolean = false;
  checkAll: boolean = false;
  candidateSkippedUnskipped: string[] = [];
  allCandidatesChecked: boolean = false;
  candidatesUnchecked: boolean = false;
  isEnableService = false;
  ptsEngineServiceResponseObj: any;
  globalServices: any = [];
  globalManagedRes: any;
  saveInProgress: boolean = false;
  FDRSStatusLoader: boolean = false;
  webSocketHandshake: boolean = false;
  fdrssubscription: Subscription = new Subscription;
  countryThree: string = '';
  dtcList: any;
  dtcInfo: boolean = true;
  dtcCandidateId: string = '';
  constructor(private router: Router, private service: ApifirstService, private modalService: NgbModal, private rpcClient: RpcClientService, private fdrsClient: FdrsClientService, private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.service.setShowWhatsNew(false);
    this.service.tokenObj.subscribe((data) => {
      this.res = data;
      this.country = this.res.country;
      this.language = this.res.language;
      this.market = this.res.marketCountry;
      this.invinnumber = this.res.vin;
      this.username = this.res.username;
      this.userType = this.res.userType;
      this.countryThree = this.res.countryThree;
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.userTypeId = 1;
        } else if (this.userType == 'PTS_DEALER') {
          this.userTypeId = 3;
        } else if (this.userType == 'PTS_AFTERMARKET') {
          this.userTypeId = 2;
        }
      }
    })
    this.service.serviceNameListservice.subscribe((data) => {
      this.globalServices = data
      for (let obj of this.globalServices) {
        if (obj.serviceName == 'PTS Service') {
          this.ptsEngineServiceResponseObj = obj;
        }
      }
    })
    this.sessionId = localStorage.getItem("sessionID");

    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
    })

    this.vinNumber = this.tokenObj.vin;

    //when click on manual dianostic btn, Requsting for NWT, After completing NWT it should return
    // Identify failure page.
    if (localStorage.getItem("manualDiagBtnClick") == 'NWTCheck') {
      localStorage.setItem("manualDiagBtnClick", " ");
      this.service.fromResume.next(false);
      this.service.getPatch(this.sessionId).subscribe((data1) => {
        let c: any = data1
      })
      this.service.userId.subscribe((data) => {
        this.userId = data
      })
      this.spinnerService.show();
      const identifyObj = {
        "vin": this.tokenObj.vin,
        "filtered": "true",
        "diagnostic": "true",
        "userId": this.userId,
        "userType": this.tokenObj.userType,
        "languageCode": this.tokenObj.language,
        "countryCode": this.tokenObj.countryThree,
        "sessionId": this.sessionId
      }
      this.service.getIdentifydetails(identifyObj).subscribe((data) => {
        this.spinnerService.hide();
        this.service.identifyDetails.next(data)
        this.router.navigateByUrl('/identifyFailure')
      })
    }

    this.service.getSkipCandidateStatusFromAdmin(this.userTypeId, this.market).subscribe((data) => {
      console.log("skip btn status:", data.parameter);
      this.skipDiagnosticProcedureArray = data.parameter;
      if (this.skipDiagnosticProcedureArray.length > 0) {
        const isFound = this.skipDiagnosticProcedureArray.some((item: any) => item.parameterKey === 'SKIP_DIAGNOSTIC_PROCEDURE');
        if (isFound) {
          for (let obj of this.skipDiagnosticProcedureArray) {
            if (obj.parameterKey == 'SKIP_DIAGNOSTIC_PROCEDURE') {
              if (obj.value == 'true') {
                this.isShowSkipCheckbox = true;
              } else {
                this.isShowSkipCheckbox = false;
              }
            }
          }
        } else {
          this.service.getSkipCandidateStatusFromAdmin(0, "default").subscribe((data) => {
            console.log("skip btn status1:", data.parameter);
            this.skipDiagnosticProcedureArray = data.parameter
            for (let obj of this.skipDiagnosticProcedureArray) {
              if (obj.parameterKey == 'SKIP_DIAGNOSTIC_PROCEDURE') {
                if (obj.value == 'true') {
                  this.isShowSkipCheckbox = true;
                } else {
                  this.isShowSkipCheckbox = false;
                }
              }
            }
          })
        }
      } else {
        this.service.getSkipCandidateStatusFromAdmin(0, "default").subscribe((data) => {
          console.log("skip btn status1:", data.parameter);
          this.skipDiagnosticProcedureArray = data.parameter
          for (let obj of this.skipDiagnosticProcedureArray) {
            if (obj.parameterKey == 'SKIP_DIAGNOSTIC_PROCEDURE') {
              if (obj.value == 'true') {
                this.isShowSkipCheckbox = true;
              } else {
                this.isShowSkipCheckbox = false;
              }
            }
          }
        })
      }
    })
    this.resumeSubscription = this.service.fromResume.subscribe((data) => {
      this.resume = data;
      console.log("subscriber called:", this.resume);
    })
    console.log(this.resume, "resume in info")
    if (!this.resume) {
      this.isshowLoader = false;
      this.timer = timer(200);
      this.subscription = this.timer.subscribe(() => {
        this.isshowLoader = true;
      });
    }
    //update page number
    const req = {
      "sessionId": localStorage.getItem("sessionID"),
      "pageid": "6"
    }
    this.service.updatePage(req).subscribe(data => { })
    this.service.isNetworkTestCompletedFromResume.subscribe((data) => {
      this.isNWTestCompletedOrOverridedFromResume = data;
    })
    this.service.showNoconnection.subscribe((data) => {
      if (data == true) {
        this.flag = true
      }
    })
    this.service.isSymptomClickHereLinkEmpty.subscribe((data) => {
      this.clickShowNoconnection = data;
      this.showNoCandidate = true;
    })
    this.service.isFDRSConnection.subscribe((data) => {
      this.isFDRSConnected = data;
    })

    this.otxDataSubscription = this.service.otxStateChangeObj.subscribe((data) => {
      this.candidateArray = data;
      if (Object.keys(this.candidateArray[0]).length > 0) {
        console.log("from html page:", this.candidateArray);
        for (let candidate of this.candidateArray) {
          if (candidate.state == 'fail - Fault found') {
            this.candidateFailed = true;
            break;
          } else {
            this.candidateFailed = false;
          }
        }
        for (let candidate of this.candidateArray) {
          if (candidate.state == 'Skipped') {
            this.changeSymptoms = true;
            break;
          } else {
            this.changeSymptoms = false;
          }
        }
        this.updateCandidate();
      }
    })

    this.pageDataSubscription = this.service.pageData.subscribe((data: any) => {
      let candidateData = this.resume ? data.diagnosticcandidates : data;
      let candidateListExist: boolean = this.resume ? data.symtoms : true;
      if (typeof candidateData !== 'string' && candidateData !== null) {
        this.arrayData = data;
        this.candidateArray = this.resume ? this.arrayData.diagnosticcandidates : this.arrayData;
        this.candidateArray.forEach((candidate: any) => {
          candidate.isCheckBoxSelected = false;
          candidate.isCheckBoxDisable = false;
          if (candidate.state == 'skipped') {
            candidate.state = 'Skipped';
            this.changeSymptoms = true;
            candidate.isCheckBoxSelected = true;
            candidate.isDisableTestViewBtns = true;
          } else if (candidate.state == 'fail') {
            this.candidateFailed = true;
            candidate.state = 'fail - Fault found';
            let faultData: any = {
              "status": 'fault',
              "isFound": true,
              "faultString": this.arrayData.faultComponentDetails[0]
            }
            this.service.diagnosticViewFaultFound.next(faultData);
          } else if (candidate.state == 'Error') {
            candidate.state = 'Error';
            candidate.isCheckBoxDisable = true;
          } else if (candidate.state == 'abort') {
            candidate.state = 'Aborted';
            candidate.isCheckBoxDisable = true;
          } else if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
            if (candidate.state == 'pass') {
              candidate.isCheckBoxDisable = true;
              candidate.state = 'Pass - no Fault';
            } else {
              candidate.state = 'Untested';
            }
          } else if (candidate.kind == 'TSB-CANDIDATE' || candidate.kind == 'GENERAL-INFORMATION-CANDIDATE' || candidate.kind == 'REPAIR-INFO-CANDIDATE' || candidate.kind == 'ETIS-CANDIDATE') {
            if (candidate.state == 'pass') {
              candidate.state = 'Pass - no Fault';
              candidate.isCheckBoxDisable = true;
            } else {
              candidate.state = 'Unread';
            }
          } else if (candidate.kind == 'PINPOINT-CANDIDATE') {
            if (candidate.state == 'pass') {
              candidate.state = 'Viewed';
              candidate.isCheckBoxDisable = true;
            } else {
              candidate.state = 'View';
            }
          }
        });
        if (this.resume) {
          this.updateCandidate();
        }
        if (this.resume && this.arrayData.faultComponentDetails) {
          this.isDiagnosticViewFaultFound = true;
          this.faultString = this.arrayData.faultComponentDetails[0];
          this.repairStatus = 'fault';
          let obj = {
            userId: this.username,
            userType: this.userType,
            languageCode: this.language,
            countryCode: this.country,
            vin: this.invinnumber,
            componentNumber: this.arrayData.faultComponentDetails[1],
            sessionid: this.sessionId
          }
          this.service.passApiResp.next(obj);
        }
        if (!this.resume) {
          this.service.otxStateChangeObj.next(this.candidateArray);
        }
      } else if (candidateData !== '' && candidateListExist) {
        this.isShowCandidateWhenNull = true;
        this.clickShowNoconnection = false;
        this.showNoCandidate = false;
      } else if (candidateData !== '' && !candidateListExist) {
        this.isShowCandidateWhenNull = false;
        this.clickShowNoconnection = false;
        this.showNoCandidate = true;
      }
    })

    this.service.passApiResp.subscribe((data) => {
      this.selectedFaultObj = data;
    })

    this.service.diagnosticViewFaultFound.subscribe((data) => {
      this.diagnosticViewStatusObj = data;
      this.manipulateDiagnosticViewObj(data);
    })

    this.service.OTXinvalidAppSkipTest.subscribe((data: any) => {
      if (Object.keys(data).length !== 0) {
        this.changeStatetoSkip(data.id, data.index, data.state);
      }
    })
  }

  ngOnDestroy() {
    this.pageDataSubscription.unsubscribe();
    this.otxDataSubscription.unsubscribe();
    this.resumeSubscription.unsubscribe();
    this.fdrssubscription.unsubscribe();
  }

  updateCandidate() {
    let candidateCount: number = this.candidateArray.length;
    let candidateDiagnosed: number = 0;
    let candidateSelected: number = 0;
    let candidateSkipped: number = 0;
    if (this.candidateFailed) {
      this.isDisableSelectAllCheckbox = true;
      this.candidateArray.forEach((candidate: any) => {
        candidate.isCheckBoxDisable = true;
      });
    } else {
      this.candidateArray.forEach((candidate: any) => {
        if (candidate.isCheckBoxDisable) {
          candidateDiagnosed++;
        } else if (candidate.isCheckBoxSelected) {
          candidateSkipped++;
        }
      });
    }
    candidateSelected = candidateDiagnosed + candidateSkipped;
    if (candidateSelected == candidateCount) {
      this.checkAll = true;
      this.showManual = true;
    } else {
      this.checkAll = false;
      this.showManual = false;
    }
    if (candidateDiagnosed == candidateCount) {
      this.isDisableSelectAllCheckbox = true;
    }
    this.showNoCandidate = false;
    this.clickShowNoconnection = true;
  }

  navigateCustomerPaidView() {
    this.service.fromResume.next(false);
    this.service.setViewIndicateComp(this.selectedFaultObj).subscribe((data) => {
      console.log('status 200 for setViewIndicateComp')
      this.router.navigate(['/warrantyDealerCode']);
    })
  }

  manipulateDiagnosticViewObj(data: any) {
    this.isDiagnosticViewFaultFound = data.isFound;
    this.faultString = data.faultString;
    this.repairStatus = data.status;
  }

  callSymptom() {
    let sessionId = localStorage.getItem("sessionID");
    localStorage.setItem("manualDiagBtnClick", " "); //resetting manual diagnostic nwt check
    this.service.changeSymptomApi(sessionId).subscribe((data) => {
      this.change = data;
    })
    this.service.fromCapture.next(true)
    this.service.navigateSymptom.next('sym')
    this.router.navigate(["/symptoms"]);
  }

  selectAllCheckbox(event: any) {
    this.allCandidatesChecked = true;
    if (event.target.checked) {
      this.candidateArray.forEach((candidate: any, index: number) => {
        if (candidate.state == 'View' || candidate.state == 'Unread' || candidate.state == 'Untested') {
          this.changeStatetoSkip(candidate.procUidRef, index, candidate.state);
          this.candidateSkippedUnskipped.push(candidate.procUidRef);
        }
      });
    } else {
      this.candidatesUnchecked = true;
      this.candidateArray.forEach((candidate: any, index: number) => {
        if (candidate.state == 'Skipped') {
          this.changeStatetoSkip(candidate.procUidRef, index, candidate.state);
          this.candidateSkippedUnskipped.push(candidate.procUidRef);
        }
      });
    }
    this.callSkipProcedureCheckedAPI(this.candidateSkippedUnskipped);
  }

  changeStatetoSkip(gid: string, index: number, procedureState: string) {
    if (procedureState == 'View' || procedureState == 'Unread' || procedureState == 'Untested') {
      this.candidateArray[index].state = 'Skipped';
      this.candidateArray[index].isCheckBoxSelected = true;
      this.candidateArray[index].isCheckBoxDisable = false;
      this.candidateArray[index].isDisableTestViewBtns = true;
      if (!this.allCandidatesChecked) {
        this.candidateSkippedUnskipped.push(gid);
        this.callSkipProcedureCheckedAPI(this.candidateSkippedUnskipped);
      }
    } else {
      for (let candidate of this.candidateArray) {
        if (gid == candidate.id) {
          if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
            candidate.state = 'Untested';
          } else if (candidate.kind == 'TSB-CANDIDATE' || candidate.kind == 'GENERAL-INFORMATION-CANDIDATE' || candidate.kind == 'REPAIR-INFO-CANDIDATE' || candidate.kind == 'ETIS-CANDIDATE') {
            candidate.state = 'Unread';
          } else if (candidate.kind == 'PINPOINT-CANDIDATE') {
            candidate.state = 'View';
          }
          break;
        }
      }
      this.candidateArray[index].isCheckBoxDisable = false;
      delete this.candidateArray[index]["isDisableTestViewBtns"];
      this.candidateArray[index].isCheckBoxSelected = false;
      if (!this.allCandidatesChecked) {
        this.candidatesUnchecked = true;
        this.candidateSkippedUnskipped.push(gid);
        this.callSkipProcedureCheckedAPI(this.candidateSkippedUnskipped);
      }
    }
  }

  callSkipProcedureCheckedAPI(gId: string[]) {
    let candidateCount: number = this.candidateArray.length;
    let candidateDiagnosed: number = 0;
    this.candidateArray.forEach((candidate: any) => {
      if (candidate.isCheckBoxDisable || candidate.isCheckBoxSelected) {
        candidateDiagnosed++;
      }
    });
    for (let candidate of this.candidateArray) {
      if (candidate.state == 'Skipped') {
        this.changeSymptoms = true;
        break;
      } else {
        this.changeSymptoms = false;
      }
    }
    if (candidateDiagnosed == candidateCount) {
      this.checkAll = true;
      this.showManual = true;
    } else {
      this.checkAll = false;
      this.showManual = false;
    }
    let req = {
      "sessionId": this.sessionId,
      "selectedCandidateReference": gId,
      "candidatesButtonAction": "SkipProcedureChecked"
    }
    if (this.candidatesUnchecked) {
      req["candidatesButtonAction"] = "SkipProcedureUnChecked";
    }
    this.saveInProgress = true;
    this.service.skipCandidate(req).subscribe((data) => {
      this.candidateSkippedUnskipped = [];
      this.allCandidatesChecked = false;
      this.candidatesUnchecked = false;
      this.saveInProgress = false;
    })
  }

  manualOnClick(content: any, networkTestInfo: any) {
    localStorage.setItem("manualDiagBtnClick", "NWTCheck");
    this.checkNetworkStatusBeforeManulaDiagnostic(content, networkTestInfo);
  }

  navigateToFdrsView(id: string, content: any, networkTestConfirmation: any, isNetworkRequired: boolean, kind: string, rating: any, title: any, procUid: any, uidRef: any, btnName: any, selectedIndex: any, currentState: any) {
    this.service.otxStateChangeObj.next(this.candidateArray);
    this.service.fromResume.next(false);
    this.service.getSelectedDiagProcdureId.next(id);
    console.log('selectedId:', id);
    if (kind == 'OTX-CANDIDATE' || kind == 'OTX-SERVFUNC-CANDIDATE' || kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
      this.service.candidateId.next(id);
      let selectedRecord = [{
        "rating": rating,
        "procedure": title,
        "state": currentState,
        "index": selectedIndex
      }]
      this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
      this.service.navigatePreviousScreen.next('diagnosticProcedure');
      this.getFDRSStatus(networkTestConfirmation, content, id);
    }
    else if (kind == 'PINPOINT-CANDIDATE' || kind == 'GENERAL-INFORMATION-CANDIDATE'
      || kind == 'REPAIR-INFO-CANDIDATE') {
      this.service.candidateId.next(id);
      const req = {
        "sessionId": localStorage.getItem("sessionID"),
        "pageid": "7"
      }
      this.service.updatePage(req).subscribe(data => { })
      this.service.diagnosticViewButtonClick(this.sessionId, id).subscribe((data) => {
        console.log("diagnostic view btn click:", data);
      })
      this.router.navigate(['/diagnostic-view'])
    }
    else if (kind == 'TSB-CANDIDATE') {
      const req = {
        "sessionId": localStorage.getItem("sessionID"),
        "pageid": "7"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.diagnosticViewButtonClick(this.sessionId, id).subscribe((data) => {
            console.log("diagnostic view btn click:", data);
          })
          this.service.updatePage(req).subscribe(data => { })
          var procUidref = procUid;
          procUidref = procUidref.substring(4);
          procUidref = procUidref.replace("/", "-")
          if (procUidref == "68-2013") {
            procUidref = "068/2013"
          }
          console.log("TSB-procUid", procUidref);
          const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
        }
        else {
          this.service.selectedGlobalServices.next('PTS Service')
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
    }
    else if (kind == 'ETIS-CANDIDATE') {
      const req = {
        "sessionId": localStorage.getItem("sessionID"),
        "pageid": "7"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.diagnosticViewButtonClick(this.sessionId, id).subscribe((data) => {
            console.log("diagnostic view btn click:", data);
          })
          this.service.updatePage(req).subscribe(data => { })
          // New Component Implementation Not Known
          const path = this.ptsUrl + "transport/?link=700&params=" + this.vinNumber + "&uid=" + uidRef + "&procuid=" + procUid;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');

        }
        else {
          this.service.selectedGlobalServices.next('PTS Service')
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
      // New Component Implementation Not Known
    } else {
      // Error Component
      this.router.navigate(['/errorCandidate'])
    }
  }

  checkNetworkStatusBeforeManulaDiagnostic(content: string, networkTestInfo: string) {
    this.service.isNetworkTestNeeded(this.vinNumber, this.userTypeId, this.countryThree).subscribe((data) => {
      if (data.status) {
        this.getFDRSStatusOnManualDiagnosticClick(content, networkTestInfo,true);
      } else {
        localStorage.setItem("manualDiagBtnClick", " ");
        localStorage.setItem("lastVisitedScreen", "")
        let sessionId = localStorage.getItem("sessionID");
        this.service.getPatch(sessionId).subscribe((data1) => {
          let c: any = data1
        })
        this.vinNumber = this.tokenObj.vin
        this.service.userId.subscribe((data) => {
          this.userId = data
        })
        const identifyObj = {
          "vin": this.vinNumber,
          "filtered": "true",
          "diagnostic": "true",
          "userId": this.userId,
          "userType": this.tokenObj.userType,
          "languageCode": this.tokenObj.language,
          "countryCode": this.tokenObj.countryThree,
          "sessionId": this.sessionId
        }
        this.service.getIdentifydetails(identifyObj).subscribe((data) => {
          this.service.identifyDetails.next(data)
          this.router.navigateByUrl('/identifyFailure')
        })
      }
    })
  }

getFDRSStatusOnManualDiagnosticClick(content: string, networkTestInfo: string,showNWTInfo: boolean) {
  localStorage.setItem("component", "fromDiagnostic")
  this.FDRSStatusLoader = true;
  this.service.getFDRSStatusInDiagnostic.next('test');
  if (localStorage.getItem("connectionState") == '1') {
    this.rpcClient.checkFDRSConnectionStatus();
  } else {
    this.fdrsClient.initFdrsClient("")
  }
  this.fdrssubscription = this.service.getFDRSStatusInDiagnostic.subscribe((data) => {
    console.log("---FDRS STATUS IN DIAGNOSTIC-----")
    if (data == 'true') {
      this.FDRSStatusLoader = false;
        if (showNWTInfo) {
          localStorage.setItem("lastVisitedScreen", "fromDiagnostic")
          this.modalService.open(networkTestInfo, { centered: true })
        } else {
          localStorage.setItem("lastVisitedScreen", "")
          let sessionId = localStorage.getItem("sessionID");
          this.service.getPatch(sessionId).subscribe((data1) => {
            let c: any = data1
          })
          this.vinNumber = this.tokenObj.vin
          this.service.userId.subscribe((data) => {
            this.userId = data
          })
          const identifyObj = {
            "vin": this.vinNumber,
            "filtered": "true",
            "diagnostic": "true",
            "userId": this.userId,
            "userType": this.tokenObj.userType,
            "languageCode": this.tokenObj.language,
            "countryCode": this.tokenObj.countryThree,
            "sessionId": this.sessionId
          }
          this.service.getIdentifydetails(identifyObj).subscribe((data) => {
            this.service.identifyDetails.next(data)
            this.router.navigateByUrl('/identifyFailure')
          })
        }
    } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && !this.webSocketHandshake) {
      this.rpcClient.checkWebSocketConnectionStatus();
      this.webSocketHandshake = true;
    } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && this.webSocketHandshake) {
      this.FDRSStatusLoader = false;
      this.webSocketHandshake = false;
      this.modalService.open(content, { centered: true })
      this.fdrssubscription.unsubscribe();
    } else if (data == 'false' && localStorage.getItem("connectionState") !== '1') {
      this.FDRSStatusLoader = false;
      this.modalService.open(content, { centered: true })
      this.fdrssubscription.unsubscribe();
    }
  })
}

dismissNetworktestInfoPopup() {
  this.fdrssubscription.unsubscribe();
}

getFDRSStatus(networkTestInfo: string, content: string, id: string) {
  localStorage.setItem("component", "fromDiagnostic")
  this.FDRSStatusLoader = true;
  this.service.getFDRSStatusInDiagnostic.next('test');
  if (localStorage.getItem("connectionState") == '1') {
    this.rpcClient.checkFDRSConnectionStatus();
  } else {
    this.fdrsClient.initFdrsClient("")
  }
  this.fdrssubscription = this.service.getFDRSStatusInDiagnostic.subscribe((data) => {
    console.log("---FDRS STATUS IN DIAGNOSTIC-----")
    if (data == 'true') {
      this.service.diagnosticViewButtonClick(this.sessionId, id).subscribe((data) => {
        console.log("diagnostic view btn click:", data);
      })
      this.FDRSStatusLoader = false;
      this.service.isNetworkTestNeeded(this.vinNumber, this.userTypeId, this.countryThree).subscribe((data) => {
        if (data.status) {
          localStorage.setItem("lastVisitedScreen", "fromDiagnostic")
          this.modalService.open(networkTestInfo, { centered: true })
        } else {
          const req = {
            "sessionId": localStorage.getItem("sessionID"),
            "pageid": "7"
          }
          this.service.updatePage(req).subscribe(data => { })
          localStorage.setItem("lastVisitedScreen", "")
          this.router.navigate(['/otxCandidate']);
        }
      });

    } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && !this.webSocketHandshake) {
      this.rpcClient.checkWebSocketConnectionStatus();
      this.webSocketHandshake = true;
    } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && this.webSocketHandshake) {
      this.FDRSStatusLoader = false;
      this.webSocketHandshake = false;
      this.modalService.open(content, { centered: true })
      this.fdrssubscription.unsubscribe();
    } else if (data == 'false' && localStorage.getItem("connectionState") !== '1') {
      this.FDRSStatusLoader = false;
      this.modalService.open(content, { centered: true })
      this.fdrssubscription.unsubscribe();
    }
  })
}

closeBtnClick() {
  // this.service.repairCompleteBtnClick(this.sessionId).subscribe((data) => {
  //   console.log("close btn click:", data);
  // })
  localStorage.setItem("component", "fromNetworkTest");
  this.service.navigatePreviousScreen.next('');
  this.router.navigate(['/closeCanceldiagnosis'])
}

cancelBtnClick() {
  this.service.cancelBtnClick(this.sessionId).subscribe((data) => {
    console.log("close btn click:", data);
    localStorage.setItem("component", "fromNetworkTest");
    this.service.navigatePreviousScreen.next('');
    this.router.navigate(['/closeCanceldiagnosis'])
  })
}

navigateToNetworkTest() {
  localStorage.setItem("component", "fromNetworkTest")
  this.router.navigate(['/closeCanceldiagnosis'])
}

ShowDTCInformation(ruleId: any, dtcInfo: any, candidateId: any) {
  let ruleStr: string = ruleId;
  let ruleIdString = ruleStr.split(/[.\#_]/);
  this.dtcCandidateId = candidateId;
  this.saveInProgress = true;
  this.service.getCandidateDTCRuleDetails(ruleIdString[0], ruleIdString[1]).subscribe((data) => {
    this.dtcList = data;
    if (Object.keys(this.dtcList).length == 0) {
      this.dtcInfo = false;
    } else {
      this.dtcInfo = true;
    }
    this.saveInProgress = false;
    this.modalService.open(dtcInfo, { size: 'md' });
  })
}

}
